import React from 'react';

// Detailed mechanical gear SVG (inspired by industrial/blueprint style)
export function Gear({ size = 200, teeth = 16, className = '', strokeWidth = 1, opacity = 1 }) {
  const r = 50;
  const innerR = 38;
  const toothLen = 8;
  const toothW = 6;

  return (
    <svg
      viewBox="-60 -60 120 120"
      width={size}
      height={size}
      className={className}
      style={{ opacity }}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Teeth */}
      {Array.from({ length: teeth }).map((_, i) => {
        const angle = (i * 360) / teeth;
        return (
          <rect
            key={i}
            x={-toothW / 2}
            y={-r - toothLen}
            width={toothW}
            height={toothLen}
            fill="currentColor"
            transform={`rotate(${angle})`}
          />
        );
      })}
      {/* Outer ring */}
      <circle cx="0" cy="0" r={r} fill="currentColor" />
      {/* Inner cutout */}
      <circle cx="0" cy="0" r={innerR} fill="#05080d" />
      {/* Spokes */}
      {[0, 60, 120, 180, 240, 300].map((a) => (
        <rect key={a} x="-3" y="-38" width="6" height="76" fill="currentColor" transform={`rotate(${a})`} />
      ))}
      {/* Center hub */}
      <circle cx="0" cy="0" r="14" fill="currentColor" />
      <circle cx="0" cy="0" r="6" fill="#05080d" />
      {/* Outline */}
      <circle cx="0" cy="0" r={innerR} fill="none" stroke="currentColor" strokeWidth={strokeWidth} opacity="0.6" />
    </svg>
  );
}

export function GearOutline({ size = 200, teeth = 24, className = '' }) {
  const r = 50;
  return (
    <svg viewBox="-60 -60 120 120" width={size} height={size} className={className}>
      {Array.from({ length: teeth }).map((_, i) => {
        const a = (i * 360) / teeth;
        return (
          <rect key={i} x="-2" y={-r - 6} width="4" height="6" fill="currentColor" transform={`rotate(${a})`} />
        );
      })}
      <circle cx="0" cy="0" r={r} fill="none" stroke="currentColor" strokeWidth="1" />
      <circle cx="0" cy="0" r={r - 8} fill="none" stroke="currentColor" strokeWidth="0.5" opacity="0.5" />
      <circle cx="0" cy="0" r="10" fill="none" stroke="currentColor" strokeWidth="1" />
      <line x1="-50" y1="0" x2="50" y2="0" stroke="currentColor" strokeWidth="0.5" opacity="0.4" />
      <line x1="0" y1="-50" x2="0" y2="50" stroke="currentColor" strokeWidth="0.5" opacity="0.4" />
    </svg>
  );
}
